import * as React from 'react';

import styles from './ImageAsDocumentMessageLayout.css';
import { EMessageType } from '../../../../types/messageType';
import { EUserColor } from '../../../../types/userName';
import { ChatMessageBubble } from '../../../ChatMessageBubble';
import { ChatMessageRow } from '../../../ChatMessageRow';
import { MetaRow } from '../MetaRow';

interface IImageAsDocumentMessageLayoutProps {
  errorSign: React.ReactNode;
  errorText: React.ReactNode;
  messageType: EMessageType;
  isLastMessageInChain: boolean;
  imageAsDocumentMessage: React.ReactNode;
  messageMeta: React.ReactNode;
  userColor?: EUserColor;
}

export const ImageAsDocumentMessageLayout = React.forwardRef<HTMLDivElement, IImageAsDocumentMessageLayoutProps>(
  function ImageAsDocumentMessageLayout(
    { errorSign, errorText, messageType, isLastMessageInChain, imageAsDocumentMessage, messageMeta, userColor },
    ref,
  ) {
    return (
      <ChatMessageRow errorSign={errorSign} errorText={errorText}>
        <ChatMessageBubble
          messageType={messageType}
          withTail={isLastMessageInChain}
          className={styles['image-as-document-message__bubble']}
          ref={ref}
          userColor={userColor}
        >
          {imageAsDocumentMessage}
          <MetaRow
            messageType={messageType}
            className={styles['image-as-document-message__meta']}
            userColor={userColor}
          >
            {messageMeta}
          </MetaRow>
        </ChatMessageBubble>
      </ChatMessageRow>
    );
  },
);
